import { useState } from "react";
import { useDesktop } from "../../hooks";
import { getCourses } from "../../data/allcourses";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { IconContext } from "react-icons";
import { IoIosPlayCircle } from "react-icons/io";
import arrowdown from "../../assets/arrowdown.svg";
import arrowup from "../../assets/arrowup.svg";
import arrowthick from "../../assets/arrowthick.svg";
import arrowUpthick from "../../assets/arrowthickUp.svg";

interface Data {
  courseContent: {
    heading: string;
    courseLectures: string;
    courseHiddenDetails: {
      details: string;
      time: string;
      hiddenDetails: string;
    }[];
  };
}

interface CourseProps {
  courses: {
    heading: string;
    courseLectures: string;
    courseHiddenDetails: {
      details: string;
      time: string;
      hiddenDetails: string;
    }[];
  };
  i: number;
}

interface hiddenDetails {
  courses: {
    heading: string;
    courseLectures: string;
    courseHiddenDetails: {
      details: string;
      time: string;
      hiddenDetails: string;
    }[];
  };
}

interface DetDetails {
  det: {
    details: string;
    time: string;
    hiddenDetails: string;
  };
  i: number;
}

const StyledDiv = styled.div`
  div {
    display: flex;
    align-items: baseline;
  }

  p {
    font-size: 0.625em;
    margin: 0 0.7em 0 0.7em;
    color: var(--vidomGray);
  }
  h4 {
    margin-left: 0.5em;
  }

  @media (min-width: 801px) {
    p {
      font-size: 0.875em;
      color: var(--vidomSecondaryBlack);
    }
    display: flex;
    justify-content: space-between;
    align-items: center;
    h3 {
      font-size: 1em;
      color: var(--vidomSecondaryBlack);
      font-weight: 400;
    }
  }
`;
const Detdiv = styled.div`
  margin-left: 1em;
  margin-top: 0.5em;

  p {
    font-size: 0.625em;
    margin: 0 0.7em 0 0.7em;
    color: var(--vidomGray);
  }

  @media (min-width: 801px) {
    margin-top: 1em;

    div {
      align-items: center;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    p {
      font-size: 0.875em;
      color: var(--vidomSecondaryBlack);
    }
  }
`;

const Coursecontent = () => {
  const params = useParams();
  const course = getCourses(params.courseId);

  const CourseComp = ({ courses, i }: CourseProps) => {
    const [isOpen, setisOpen] = useState(false);

    // duplicate code to be replaced when api is ready
    const HiddenDet = ({ courses }: hiddenDetails) => {
      const NextDiv = ({ det, i }: DetDetails) => {
        const [index, setIndex] = useState(false);
        return (
          <div className="next-div">
            <div
              key={i}
              onClick={() => setIndex(!index)}
            >
              <div className="coursecontent-det-showcase">
                <IoIosPlayCircle className="play-circle" />
                <p>{det.details}</p>
                <img
                  src={index ? arrowUpthick : arrowthick}
                  alt="arrowdown"
                  width="10"
                  height="7"
                />
              </div>
              {useDesktop() >= 1024 && (
                <p className="course-time">{det.time}</p>
              )}
            </div>
            {useDesktop() >= 1024 && index && (
              <p className="course-hidden-details">{det.hiddenDetails}</p>
            )}
          </div>
        );
      };

      return (
        <>
          {courses.courseHiddenDetails.map((det, index) => (
            <Detdiv key={index}>
              <NextDiv
                det={det}
                i={index}
              />
            </Detdiv>
          ))}
        </>
      );
    };

    return (
      <div key={i}>
        <StyledDiv
          className="course-content-header"
          onClick={() => setisOpen(!isOpen)}
        >
          <div>
            <img
              src={isOpen ? arrowup : arrowdown}
              className="course-arrows"
              alt="arrowdown"
              width="10"
              height="7"
            />
            <h4>{courses.heading}</h4>
          </div>

          {useDesktop() >= 1024 && <h3>{courses.courseLectures}</h3>}
        </StyledDiv>
        {isOpen && (
          <div className="course-dropdown-comp">
            <IconContext.Provider value={{ className: "course-icons" }}>
              <HiddenDet courses={courses} />
            </IconContext.Provider>
          </div>
        )}
      </div>
    );
  };

  const CourseContent = (): JSX.Element => {
    return (
      <>
        {course?.courseContent.map(
          (courses: Data["courseContent"], i: number) => (
            <div key={i}>
              <CourseComp
                courses={courses}
                i={i}
              />
            </div>
          ),
        )}
      </>
    );
  };

  return (
    <div className="course-content-container">
      <CourseContent />
    </div>
  );
};

export default Coursecontent;
